module.exports = __webpack_public_path__ + "static/media/spotify-music-logo.cc8b7b26.svg";